import { supabase } from "@/integrations/supabase/client";

interface ConversationVisionResult {
  descriptionText: string;
}

const DEFAULT_PROMPT =
  "Analyze this image and describe in 1-2 concise sentences what is shown, focusing on objects, environment, and any details that might be helpful for a support assistant talking to a consumer. Extract ALL text exactly, do not summarize";
const ANALYSIS_TIMEOUT_MS = 20_000;

export class ConversationImageAnalysisService {
  public static async analyzeImage(imageDataBase64: string): Promise<ConversationVisionResult | null> {
    try {
      let timeoutId: number | undefined;
      const { data, error } = await Promise.race([
        supabase.functions.invoke("analyze-image-vision", {
          body: {
            imageData: imageDataBase64,
            prompt: DEFAULT_PROMPT,
          },
        }),
        new Promise<never>((_, reject) => {
          timeoutId = window.setTimeout(() => reject(new Error("Image analysis timed out")), ANALYSIS_TIMEOUT_MS);
        }),
      ]);
      if (timeoutId !== undefined) window.clearTimeout(timeoutId);

      if (error) {
        console.error("[ConversationImageAnalysisService] analyze-image-vision error:", error);
        return null;
      }

      if (!data || typeof data.response !== "string") {
        // Edge function in this project is expected to return { descriptionText: string }
        console.warn("[ConversationImageAnalysisService] Unexpected response shape from analyze-image-vision:", data);
        return null;
      }

      return {
        descriptionText: data.response,
      };
    } catch (err) {
      console.error("[ConversationImageAnalysisService] Failed to analyze image:", err);
      return null;
    }
  }
}

